








































































import { Component, Vue } from "vue-property-decorator";

import { Plant, PlantImage, Image } from "@/types";
import { className } from "@/utilities";

import PlantBackground from "@/components/PlantBackground.vue";

@Component({
  components: {
    PlantBackground,
  },
})
export default class BorderView extends Vue {
  get number() {
    return this.$route.params.plant;
  }

  get plant() {
    return this.$store.state.plants[this.number] as Plant;
  }

  get plantImage() {
    return this.$store.state.images[this.number] as PlantImage;
  }

  get images() {
    return [
      ...this.plantImage.gardenImages,
      ...this.plantImage.googleImages.filter((i) => i.imageLink),
      {
        image:
          "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
      },
      {
        image:
          "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
      },
      {
        image:
          "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
      },
      {
        image:
          "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
      },
    ];
  }

  get mainImage(): Image | null {
    if (this.plantImage) {
      if (this.plantImage.gardenImages.length > 0) {
        return this.plantImage.gardenImages[0];
      } else if (this.plantImage.googleImages.length > 0) {
        return this.plantImage.googleImages[0];
      }
    }
    return {
      image:
        "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
    };
  }

  get typeClassName() {
    return className(this.plant.type);
  }

  get locations() {
    return this.$store.getters.findPlantInGarden(this.plant.number);
  }

  locationName(zone: string, border: string) {
    return this.$store.getters.getLocationName(zone, border);
  }
}
